import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './ConfirmDeleteModal.css';

export default function ConfirmDeleteModal({
  open,
  title,
  message,
  confirmLabel,
  markerTitle,
  onConfirm,
  onCancel,
}) {
  const [typed, setTyped] = useState('');

  useEffect(() => {
    if (!open) { setTyped(''); return; }
    const onKey = (e) => { if (e.key === 'Escape') onCancel(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onCancel]);

  if (!open) return null;

  const displayTitle   = title   || (markerTitle ? `„${markerTitle}" löschen?` : 'Endgültig löschen?');
  const displayMessage = message || (markerTitle
    ? `${markerTitle} wird dauerhaft entfernt. Diese Aktion kann nicht rückgängig gemacht werden.`
    : 'Diese Aktion kann nicht rückgängig gemacht werden.');
  const displayConfirm = confirmLabel || 'Endgültig löschen';
  const confirmed = typed === 'DELETE';

  return createPortal(
    <div className="cdm-overlay" role="dialog" aria-modal="true" aria-labelledby="cdm-title">
      <button className="cdm-backdrop" onClick={onCancel} aria-label="Abbrechen" tabIndex={-1} />

      <div className="cdm-card">
        <div className="cdm-icon-wrap" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
            strokeLinecap="round" strokeLinejoin="round" width="26" height="26">
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
            <path d="M10 11v6M14 11v6" />
            <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
          </svg>
        </div>

        <div className="cdm-title" id="cdm-title">{displayTitle}</div>
        <div className="cdm-sub">{displayMessage}</div>

        <div className="cdm-warning">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
            strokeLinecap="round" strokeLinejoin="round" width="12" height="12" aria-hidden="true">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
          Nicht wiederherstellbar
        </div>

        <div className="cdm-confirm-field">
          <label className="cdm-confirm-label" htmlFor="cdm-confirm-input">
            Zur Bestätigung <strong>DELETE</strong> eingeben
          </label>
          <input
            id="cdm-confirm-input"
            className="cdm-confirm-input"
            type="text"
            value={typed}
            onChange={e => setTyped(e.target.value)}
            placeholder="DELETE"
            autoComplete="off"
            spellCheck={false}
          />
        </div>

        <div className="cdm-actions">
          <button className="cdm-btn cdm-btn--ghost" onClick={onCancel}>
            Abbrechen
          </button>
          <button
            className="cdm-btn cdm-btn--danger"
            onClick={onConfirm}
            disabled={!confirmed}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"
              strokeLinecap="round" strokeLinejoin="round" width="13" height="13" aria-hidden="true">
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
              <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
            </svg>
            {displayConfirm}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
